module.exports = __webpack_public_path__ + "static/img/model-bg30.fc7bb27.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg30.jpg
// module id = Mf6u
// module chunks = 0